export interface PasswordResetResponseModel {
  hasError: boolean;
  errorMessage: string;
}
